import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import crossModalImg from '../../../assets/images/crossModal.png';
import { addWebhookSettings } from '../../../redux/actions/webhookSettings';
import Loader from '../../Loader';
import isURL from 'validator/lib/isURL';

const WebhookFromModal = ({ modalOpen, setModalOpen }) => {
	const [webhookForm, setWebhookForm] = useState({ title: '', url: '' });

	const dispatch = useDispatch();

	const webhookSettings = useSelector((state) => state.webhookSettings);

	const { loading, success } = webhookSettings;

	useEffect(() => {
		if (success) {
			setModalOpen(false);
			setWebhookForm({ title: '', url: '' });
		}
	}, [success, setModalOpen]);

	const submitWebhookForm = () => {
		const { title, url } = webhookForm;
		if (!title.trim() || !url) {
			toast.error('Please fill all required fields!');
			return false;
		}

		if (isURL(url)) dispatch(addWebhookSettings({ title, url }));
		else toast.error('Please provide a valid url');
	};

	return (
		// <!-- Modal Sectionis activated by Toogling the className activated. -->
		<>
			{loading && <Loader />}
			<div className={`modalDivWraper customizedModal ${modalOpen ? 'activated' : ''}`}>
			<div className="modalHeaderWraper">
					{/* <img
						src={crossModalImg}
						className='modalCloseBtn'
						alt=''
						onClick={() => setModalOpen(false)}
					/> */}
					<h4 className='modalHeading'>Add Webhook</h4>
			</div>
				<div className='innerModalWraper'>

					<div className='fieldWrapers modalFields'>
					<div className="indformField">
					<span className="labelFields">Enter Key/Title</span>
						<input
							type='text'
							className='inputBox'
							placeholder='Key/Title'
							onChange={(e) =>
								setWebhookForm({ ...webhookForm, title: e.target.value })
							}
						/>
						</div>
						<div className="indformField">
						<span className="labelFields">Enter Webhook URL</span>
						<input
							type='text'
							className='inputBox'
							placeholder='Webhook URL'
							onChange={(e) =>
								setWebhookForm({ ...webhookForm, url: e.target.value })
							}
						/>
						</div>
						<div className='buttonWraper customizeWraper'>
							<button className='confirmBtn' onClick={submitWebhookForm}>
								Submit
							</button>
							<button className='cancelBtn' onClick={() => setModalOpen(false)}>
								Cancel
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default WebhookFromModal;
